import apiClient from '../client.js'

async function createTrigger(scope, payload) {
  return apiClient.post(`/${scope}/tickets/triggers`, payload)
}

async function updateTrigger(scope, id, patch) {
  return apiClient.patch(`/${scope}/tickets/triggers/${id}`, patch)
}

async function updateTriggerActive(scope, id, active) {
  return apiClient.patch(`/${scope}/tickets/triggers/${id}/active`, { active })
}

async function deleteTrigger(scope, id) {
  return apiClient.delete(`/${scope}/tickets/triggers/${id}`)
}

class TriggerService {
  create = {
    /**
     * Create a trigger under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async trigger(scope, payload) {
      return createTrigger(scope, payload)
    },
  }

  update = {
    /**
     * Update one trigger under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {object} patch
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async trigger(scope, id, patch) {
      return updateTrigger(scope, id, patch)
    },

    /**
     * Set a trigger's active flag under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {boolean} active
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async active(scope, id, active) {
      return updateTriggerActive(scope, id, active)
    },
  }

  delete = {
    /**
     * Delete one trigger under the settings scope.
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<import('axios').AxiosResponse>}
     */
    async trigger(scope, id) {
      return deleteTrigger(scope, id)
    },
  }
}

export default new TriggerService()
